import {
    ApolloLink,
    Operation,
    FetchResult,
    Observable,
  } from '@apollo/client/core';
  import { print } from 'graphql';
  import { createClient, ClientOptions, Client, RequestParams } from 'graphql-sse';


  // NOTE: Example taken from here: https://the-guild.dev/graphql/sse/recipes#with-apollo
  export class SSELink extends ApolloLink {
    private client: Client;
   
    constructor(options: ClientOptions) {
      super();
      this.client = createClient(options);
    }
   
    public request(operation: Operation): Observable<FetchResult> {
      return new Observable((sink) => {
        const request: RequestParams = {
          query: print(operation.query),
          variables: operation.variables,
          operationName: operation.operationName,
          extensions: operation.extensions,
        };

        return this.client.subscribe<FetchResult>(
          request,
          {
            next: sink.next.bind(sink),
            complete: sink.complete.bind(sink),
            error: sink.error.bind(sink),
          },
        );
      });
    }
  }
